import React, { FC, useState } from 'react';

import { AtsType, IntegrationType } from 'src/generated/mloop-graphql';

import { LeverIntegration, useIntegrationAuthorizeUrl, useIntegrationDelete } from 'src/hooks/api/integration';
import { getAtsService } from 'src/hooks/atsService';

import { DisconectAtsDialog } from '../Dialogs/DisconnectAtsDialog';
import IntegrationCard from '../IntegrationCard';

import { ConnectAtsButton } from './ConnectAtsButton';

export interface Props {
  lever?: LeverIntegration;
  disabled?: boolean;
  onRemove?: () => void;
}

const LeverCard: FC<Props> = ({ lever, disabled = false, onRemove }) => {
  const [openRemoveDialog, setOpenRemoveDialog] = useState<boolean>(false);

  const { data: leverAuthData } = useIntegrationAuthorizeUrl({
    integration_type: IntegrationType.Lever,
    redirect_uri: '',
    login_hint: '',
  });
  const deleteLever = useIntegrationDelete(IntegrationType.Lever);

  const atsService = getAtsService(AtsType.Lever);

  return (
    <>
      <IntegrationCard
        dataTestId="lever-card-integration-card"
        logo={atsService.logoUrl}
        name="Lever"
        onConnect={!lever?.active && leverAuthData ? () => window.open(leverAuthData.url, '_blank') : undefined}
        onReconnect={lever?.active && leverAuthData ? () => window.open(leverAuthData.url, '_blank') : undefined}
        onRemove={lever?.active ? () => setOpenRemoveDialog(true) : undefined}
        disabled={disabled}
        disableManageSetup={disabled}
        connectButton={
          <ConnectAtsButton
            dataTestId="lever-card-integration-card"
            handleConnect={() => window.open(leverAuthData?.url, '_blank')}
            disabled={disabled}
          />
        }
      />

      {openRemoveDialog && (
        <DisconectAtsDialog
          integrationName={atsService.name}
          onClose={() => setOpenRemoveDialog(false)}
          onRemove={() => {
            setOpenRemoveDialog(false);
            deleteLever.mutate(undefined, {
              onSuccess: () => {
                onRemove?.();
              },
            });
          }}
        />
      )}
    </>
  );
};

export default LeverCard;
